import { useTranslation } from 'react-i18next';
import i18n from '@benzinga/translate';

export const Complete = () => {
  const { t } = useTranslation('auth', { i18n });
  const nextParam = new URLSearchParams(window.location.search).get('next');

  const goNext = () => {
    const next = nextParam ? decodeURIComponent(nextParam) : '/';
    window.location.href = next;
  };

  return (
    <div>
      <div className="pt-8">
        <div className="mb-8">
          <h1 className="text-white">{t('Auth.Register.thank-you')}</h1>
          <p>{t('Auth.Register.completed')}</p>
        </div>
        <button
          className="bg-[#3f83f8] text-white p-3 hover:bg-[#3268c4] border border-white rounded-md w-full"
          onClick={goNext}
          type="submit"
        >
          {t('Auth.Register.return-to-app')}
        </button>
      </div>
    </div>
  );
};
